<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				start
				icon="$search"
			/>
			<translate>View Preview</translate>
		</v-card-title>
		<v-card-text class="pb-0">
			<div
				v-for="model in models"
				:key="model.name"
			>
				<v-text-field
					v-model="model.value"
					:label="model.name"
					variant="outlined"
				/>
			</div>
		</v-card-text>
		<v-card-actions>
			<v-spacer />
			<v-btn
				color="primary"
				type="submit"
				@click="pdfSubmit"
			>
				<translate>PDF</translate>
			</v-btn>
			<v-btn
				color="primary"
				type="submit"
				@click="htmlSubmit"
			>
				<translate>HTML</translate>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>

export default {
	name: 'PdfTemplatePreview',

	props: {
		templateModels: {
			type: String,
			required: true
		},
		id: {
			type: Number,
			required: true
		}
	},

	computed: {
		models: function () {
			const splitModels = this.templateModels.split(',');
			const models = [];

			splitModels.forEach(function (modelName) {
				models.push(
					{
						name: modelName,
						value: ''
					}
				);
			});
			return models;
		}
	},

	methods: {
		/**
		 * determine url based on models
		 *
		 * @returns {string}
		 */
		getUrl () {
			let url = `/bo/pdfpreview?id=${this.id}&`;

			this.models.forEach(function (model) {
				url = url + `${model.name.toLowerCase()}_id=${model.value}&`;
			});
			return url;
		},

		/**
		 * open the pdf in a new window
		 */
		pdfSubmit () {
			window.open(this.getUrl() + 'output=PDF');
		},

		/**
		 * open the html in a new window
		 */
		htmlSubmit () {
			window.open(this.getUrl() + 'output=HTML');
		}
	}

};
</script>
